//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex';
import LanguageMixin from '@motionelements/core/src/components/mixins/language.mixin.js';

export default {
  name: 'main-menu-language-list',
  mixins: [LanguageMixin],
  props: {
    onChange: Function,
  },
  data() {
    return {
      navigatorLanguages: [],
    };
  },
  mounted() {
    this.navigatorLanguages = window.navigator.languages;
  },
  computed: {
    ...mapState({
      languages: state => state.app.languages,
    }),
    activeLanguageCode() {
      return this.$i18n.locale;
    },
    navigatorLanguageCodes() {
      return this.navigatorLanguages.map((code) => {
        if (code === 'zh-CN') {
          return 'zh-hans';
        }
        const languageCode = code.split('-')[0];
        return languageCode === 'zh' ? 'zh-hant' : languageCode;
        // use .split('-')[0] to compare zh-CN or other with zh-hans
        // return code.split('-')[0] === 'zh' ? 'zh-hans' : code.split('-')[0];
      });
    },
    browserLanguageCodes() {
      // create arrow of activeLanguageCode and browserLanguageCodes without duplicates
      return [...new Set([
        this.activeLanguageCode, // Always show selected language first
        'en', // Always include English next to selected language
        ...this.navigatorLanguageCodes,
      ])];
    },
    suggestedLanguagesCodes() {
      const suggestedLanguagesCodes = this.browserLanguageCodes
          .filter(code => !!this.languages.find(language => language.code === code));
      return suggestedLanguagesCodes.length > 1 ? suggestedLanguagesCodes.slice(0, 3) : [];
    },
    suggestedLanguages() {
      return this.suggestedLanguagesCodes.map(languageCode => this.languages.find(({ code }) => code === languageCode));
    },
    otherLanguages() {
      return this.languages.filter(language => !this.suggestedLanguagesCodes.includes(language.code));
    },
  },
  methods: {
    onLanguageClick(languageCode) {
      this.onChangeLanguage(languageCode);
      this.$nextTick(() => {
        this.$emit('onChange');
      });
    },
  },
};
